import qs from 'query-string';
import SuperFetchV2 from '../../superFetchV2';

class categoryApi {
  /**
   * 카테고리 리스트 가져오기
   * @param {string} queryString - 카테고리 리스트 필터 옵션에 의해 만들어진 쿼리스트링
   * @return {AxiosPromise<any>}
   */
  getCategoryList = (queryString) => SuperFetchV2.get(`/categories${queryString}`);

  /**
   * 카테고리 리스트 삭제하기
   * @param {string} categoryIds - 삭제할 카테고리 id 배열(csv 형태)
   * @returns {AxiosPromise}
   */
  deleteCategoryList = (categoryIds) => SuperFetchV2.delete(`/categories/${categoryIds}`);

  /**
   * 카테고리 리스트 엑셀 다운로드
   * @param {string} queryString - 카테고리 리스트 필터 옵션에 의해 만들어진 쿼리스트링
   * @return {AxiosPromise<any>}
   */
  getCategoryExcelDownload = (queryString) => SuperFetchV2.get(`/files/excel-download/categories${queryString}`);

  /**
   * 카테고리 생성하기
   * 카테고리 상품 리스트 엑셀 다운로드
   * @param {string} queryString - 카테고리 상품 리스트 필터 옵션에 의해 만들어진 쿼리스트링
   * @return {AxiosPromise<any>}
   */
  getCategoryProductExcelDownload = (queryString) => SuperFetchV2.get(`/files/excel-download/products${queryString}`);

  /**
   * 카테고리 생성하기
   * @param {object} data - 카테고리 생성에 필요한 요청 데이터
   * @param {number} data.type - 카테고리 타입
   * @param {number} data.status - 카테고리 활성 상태
   * @param {number} data.exposureType - 카테고리 노출 타입
   * @param {number} data.sortType - 카테고리 정렬 타입
   * @param {string} data.name - 카테고리 명
   * @param {string} [data.subText] - 강조형 카테고리 subText
   * @param {string} [data.memo] - 카테고리 수정 및 생성 사유
   * @return {AxiosPromise<any>}
   */
  createCategory = (data) => SuperFetchV2.post('/categories', data);

  /**
   *  카테고리 상세 데이터 가져오기
   *  @param {number} id - 카테고리 ID
   *  @return {Promise<any>}
   */
  getCategoryDetail = (id) => SuperFetchV2.get(`/categories/${id}`);

  /**
   *  카테고리 수정 이력 리스트 가져오기
   *  @param {number} id - 카테고리 ID
   *  @param {object} param - 필터 옵션
   *  @return {Promise<any>}
   */
  getCategoryHistoryList = (id, param) => SuperFetchV2.get(`/categories/${id}/histories?${qs.stringify(param)}`);

  /**
   * 1차 카테고리 편집하기
   * @param {number} id - 카테고리 ID
   * @param {object} data - 카테고리 편집에 필요한 요청 데이터
   * @param {object} data.category - 편집 요청한 1차 카테고리 정보
   * @param {string} data.category.name - 1차 카테고리 명
   * @param {number} data.category.status - 1차 카테고리 활성 상태
   * @param {string} data.category.subText - 1차 강조형 카테고리 subText
   * @param {string} data.category.memo - 1차 카테고리 수정 및 생성 사유
   * @param {number} data.category.sortType - 1차 카테고리 정렬 타입
   * @return {AxiosPromise<any>}
   */
  editCategory = (id, data) => SuperFetchV2.patch(`/categories/${id}`, data);

  /**
   *  2차 카테고리 리스트 가져오기
   *  @param {number} id - 카테고리 ID
   */
  getSubCategoryList = (id) => SuperFetchV2.get(`/categories/${id}/sub-categories`);

  /**
   *  2차 카테고리 생성하기
   *  @param {number} id - 카테고리 ID
   *  @param {{name: string, status: number}} data - 카테고리 data
   */
  createSubCategory = (id, data) => SuperFetchV2.post(`/categories/${id}/sub-categories`, data);

  /**
   *  2차 카테고리 수정하기
   *  @param {number} id - 카테고리 ID
   *  @param {number} subId - 2차 카테고리 ID
   *  @param {{name: string, status: number}} data - 카테고리 data
   */
  editSubCategory = (id, subId, data) => SuperFetchV2.patch(`/categories/${id}/sub-categories/${subId}`, data);

  /**
   *  2차 카테고리 삭제하기
   *  @param {number} id - 카테고리 ID
   *  @param {number} subId - 2차 카테고리 ID
   */
  deleteSubCategory = (id, subId) => SuperFetchV2.delete(`/categories/${id}/sub-categories/${subId}`);

  /**
   * 카테고리 상품 삭제하기
   * @param {object} data - 카테고리 상품 삭제 응답 데이터
   * @param {number} data.categoryId - 카테고리 ID
   * @param {number[]} data.productIds - 삭제할 상품들의 ID 배열
   * @return {AxiosPromise<any>}
   */
  deleteCategoryProduct = (data) => SuperFetchV2.delete('/relationships/product-category', { data });

  /**
   * 카테고리 리스트 트리 불러오기
   */

  /**
   * 카테고리 리스트 트리 불러오기
   * @param {string} queryString - 카테고리 전시 여부 필터 옵션에 의해 만들어진 쿼리스트링
   * @return {AxiosPromise<any>}
   */
  getCategoryListTree = (queryString) => SuperFetchV2.get(`/categories/tree${queryString}`);

  /**
   * 카테고리 전시 순서 변경하기
   * @param {object} data - 카테고리 전시 순서 변경을 위해 요청하는 데이터
   * @param {object[]} data.normalCategories - 전시하는 일반형 카테고리
   * @param {number} data.normalCategories.id - 일반형 카테고리 고유 ID
   * @param {string} data.normalCategories.name - 일반형 카테고리 명
   * @param {object[]} [data.normalCategories.subCategories] - 해당 일반형 카테고리의 자식 카테고리
   * @param {number} data.normalCategories.subCategories.id - 일반형 자식 카테고리 ID
   * @param {string} data.normalCategories.subCategories.name - 일반형 자식 카테고리 명
   * @param {object[]} data.emphasisCategories - 전시하는 강조형 카테고리
   * @param {number} data.emphasisCategories.id - 강조형 카테고리 고유 ID
   * @param {string} data.emphasisCategories.name - 강조형 카테고리 명
   * @param {object[]} data.emphasisCategories.subCategories - 해당 강조형 카테고리의 자식 카테고리
   * @param {number} data.emphasisCategories.subCategories.id - 강조형 자식 카테고리 ID
   * @param {string} data.emphasisCategories.subCategories.name - 강조형 자식 카테고리 명
   * @return {AxiosPromise<any>}
   */
  editCategoryExhibitOrder = (data) => SuperFetchV2.post('/categories/exhibition', data);

  /**
   * 카테고리 별 후기 평가 항목 조회하기
   * @param {number} id - The id of the category.
   * @returns {AxiosPromise<ReviewCriteriaFindResponseDto>} The API response.
   */
  getCategoryReviewCriteria = (id) => SuperFetchV2.get(`/categories/${id}/review-criteria`);
}

export default new categoryApi();
